import { startMain } from './startMain';
import css from '!!css-loader!./attendees/style.css';
import template from './attendees/template.html';

startMain(function () {
  type Attendee = {
    FirstName: string,
    LastName: string,
    Country: string,
    Institution: string,
    RegNr: string,
  }
  function attendeeToHtml(attendee: Attendee): string {
    return `
<div class="gs-attendee">
  <div class="gs-attendee-name">${attendee.LastName}, ${attendee.FirstName}</div>
  <div class="gs-attendee-detail hidden">
    <span class='name'>${attendee.FirstName} ${attendee.LastName}</span><br>
    <span>${attendee.Institution}</span><br>
    <span>${attendee.Country}</span>
  </div>
</div>
`
  }

  var parentContainer: HTMLElement = document.getElementById('gsa-attendee-list-container');
  fetch(parentContainer.dataset['url'])
    .then(response => response.json())
    .then(function (result: Attendee[]) {
      var container: HTMLElement = parentContainer;
      var style = document.createElement('style');
      style.textContent = css.toString();
      // this emoji plugin is way too slow, take 2s on desktop and longer on phone
      // hack to disable it
      if (parentContainer.attachShadow) {
        parentContainer.attachShadow({ mode: 'open' });
        var shadowRoot = parentContainer.shadowRoot;
        let wrapper = document.createElement("div");
        shadowRoot.appendChild(style);
        shadowRoot.appendChild(wrapper);
        container = wrapper;
      } else {
        document.head.appendChild(style);
      }

      var attendeesHtml = result.map(a => attendeeToHtml(a)).join('');


      container.innerHTML = template;
      var attendeesListElem = container.querySelector('#gs-attendees-list');
      attendeesListElem.innerHTML = attendeesHtml;
      var countElem = container.querySelector('#gs-attendees-count');
      var activeTab = '';
      var lastState = result.map(a => true);
      var lastDetailState = result.map(a => false);
      var searchTextElem = container.querySelector('#gs-attendees-search-text') as HTMLInputElement;
      var attendeeLastNameIndex = null;
      var debouncdTimeout = null;
      var searchIndex: string[] | null = null;
      countElem.textContent = result.length.toString();
      var attendeeElems = attendeesListElem.children;
      var attendeeDetailElems = container.querySelectorAll(".gs-attendee-detail");
      for (var i = 0; i < attendeeElems.length; ++i) {
        if (i % 2 === 0) {
          attendeeElems[i].classList.add("gs-odd");
        }
      }

      function showHideDetial(i: number, showDetail: boolean) {
        if (lastDetailState[i] !== showDetail) {
          lastDetailState[i] = showDetail
          if (showDetail) {
            attendeeDetailElems[i].classList.remove('hidden');
          } else {
            attendeeDetailElems[i].classList.add('hidden');
          }
        }
      }
      function showHideRow(i: number, show: boolean, isOddRow: boolean) {
        if (isOddRow) {
          attendeeElems[i].classList.add('gs-odd');
        } else {
          attendeeElems[i].classList.remove('gs-odd');
        }

        if (lastState[i] !== show) {
          lastState[i] = show
          if (show) {
            attendeeElems[i].classList.remove('hidden');
          } else {
            attendeeElems[i].classList.add('hidden');
          }
        }
      }

      // remove accent letters and lower case
      function toSearchIndex(str: string): string {
        if (str.normalize) {
          return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        } else {
          // for ie, which don't support normalize, ignore this step
          return str.toLowerCase();
        }
      }

      function buildSearchIndex(attendees: Attendee[]): string[] {
        return result.map((attendee) => {
          var content = [attendee.FirstName, attendee.LastName, attendee.Institution, attendee.Country].join(' ');
          return toSearchIndex(content);
        });
      }

      function refresh() {
        var text = searchTextElem.value;
        text = toSearchIndex(text);
        let showDetail = text !== '';
        var count = 0;
        for (var i = 0; i < result.length; ++i) {
          let attendee = result[i];
          let show = true;
          if (text) {
            if (searchIndex === null) {
              searchIndex = buildSearchIndex(result);
            }
            if (searchIndex[i].indexOf(text) === -1) {
              show = false;
            }
          }

          if (activeTab !== '') {
            if (attendeeLastNameIndex === null) {
              attendeeLastNameIndex = result.map(a => a.LastName.charAt(0).toUpperCase());
            }
            if (attendeeLastNameIndex[i] !== activeTab) {
              show = false;
            }
          }
          showHideRow(i, show, count % 2 === 0);
          showHideDetial(i, showDetail && show);
          if (show) {
            count++;
          }
        }
        countElem.textContent = count.toString();
      }

      var tabElems = container.querySelectorAll('#gs-attendees-tab a');
      for (var i = 0; i < tabElems.length; i++) {
        tabElems[i].addEventListener('click', function (e) {
          const currActive = container.querySelector(".active");
          currActive && currActive.classList.remove("active");
          const tabElem = e.target as HTMLElement;
          tabElem.classList.add("active");
          activeTab = tabElem.textContent;
          if (activeTab === "All") {
            activeTab = ''
          }
          clearTimeout(debouncdTimeout);
          debouncdTimeout = setTimeout(refresh, 300);
        });
      }
      searchTextElem.addEventListener('input', (e) => {
        clearTimeout(debouncdTimeout);
        debouncdTimeout = setTimeout(refresh, 300);
      })

      container.querySelectorAll('.gs-attendee-name').forEach(function (e, i) {
        e.addEventListener('click', function (e) {
          showHideDetial(i, !lastDetailState[i]);
        });
      });

    });
});
